import * as types from "./ActionTypes";
import InitialState from "Store/InitialState";
import produce from "immer";
import log from "loglevel";

export const LabsReducer = (state = InitialState.labs, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.LOAD_ALL_LABS: {
        // Stores all labs - used by reorder mode (V2) and as primary data source (V1)
        // action.payload is the full API response: { labs: [...], access_control_vars: {...}, ... }
        const payload = action.payload
        const allLabsList = payload.labs || payload || []
        draft.allLabs = allLabsList
        // Also populate labs for V1 components that read state.labs.labs
        draft.labs = allLabsList
        if (payload.access_control_vars) {
          draft.access_control_vars = payload.access_control_vars
        }
        if (payload.stats) {
          draft.stats = payload.stats
        }
        break
      }

      case types.LOAD_LABS_PAGINATED: {
        // Server-side paginated response
        draft.labs = action.payload.labs?.results || action.payload.labs || []
        draft.totalCount = action.payload.labs?.count || 0
        draft.stats = action.payload.stats || draft.stats
        draft.accessControlVars = action.payload.access_control_vars || {}
        break
      }

      case types.CREATE_LAB: {
        draft.labs.push(action.payload.lab)
        break
      }

      case types.UPDATE_LAB: {
        draft.labs = draft.labs.map((item) =>
          item.id === action.payload.lab.id ? action.payload.lab : item
        )
        break
      }

      case types.BULK_UPDATE_LAB_VISIBILITY: {
        const { labIds, isVisible } = action.payload
        draft.labs = draft.labs.map((item) => {
          if (labIds.includes(item.id)) {
            return { ...item, is_lab_visible: isVisible }
          }
          return item
        })
        break
      }

      case types.REORDER_LABS_SUCCESS: {
        draft.allLabs = [...action.payload]
        break
      }

      case types.DELETE_LAB: {
        draft.labs = draft.labs.filter((item) => item.id !== action.payload)
        break
      }

      case types.CREATE_ACTIVITY: {
        const lab = draft.labs.find((item) => item.id === action.payload.labId)
        if (lab) {
          lab.activity_set = lab.activity_set || []
          lab.activity_set.push(action.payload.activity)
        }
        break
      }

      case types.UPDATE_ACTIVITY: {
        const labForUpdate = draft.labs.find((l) => l.id === action.payload.labId)
        if (labForUpdate) {
          const activityIndex = labForUpdate.activity_set.findIndex(
            (ac) => ac.id === action.payload.activity.id
          )
          if (activityIndex !== -1) {
            labForUpdate.activity_set[activityIndex] = action.payload.activity
          }
        }
        break
      }

      case types.DELETE_ACTIVITY: {
        const labForDelete = draft.labs.find((l) => l.id === action.payload.labId)
        if (labForDelete) {
          labForDelete.activity_set = labForDelete.activity_set || []
          labForDelete.activity_set = labForDelete.activity_set.filter(
            (act) => act.id !== action.payload.activityId
          )
        }
        break
      }

      case types.REORDER_ACTIVITIES_SUCCESS: {
        const { labId, activities } = action.payload
        const labForReorder = draft.labs.find((l) => l.id === labId)
        if (labForReorder) {
          labForReorder.activity_set = [...activities]
        }
        break
      }

      default:
        break
    }
  })
}
